import { Box, VStack, Text, Flex } from "@chakra-ui/react";
import { Suspense, lazy, useState } from "react";
import logoSagaAzulAnim from "../assets/animations/logo-saga-azul.json";

// lottie-react/lottie-web es pesado de parsear/ejecutar; se separa en su
// propio chunk para no sumar al JS crítico del primer render del Hero.
const Lottie = lazy(() => import("lottie-react"));
import HeroInput from "./chat/common/HeroInput";
import QuickQuestions from "./chat/QuickQuestions";
import { PrimaryButton } from "./common/PrimaryButton";
import Chat from "./chat/common/Chat";
import { useChatStore } from "./chat/store/chat.store";
import { useScroll } from "../context/ScrollContext";

const quickQuestions = [
  "¿Cómo obtiene SAGA Fiscal mi información fiscal?",
  "¿Qué tipo de CFDIs puedo consultar en la plataforma?",
  "¿Puedo ver mis impuestos desglosados por régimen?",
  "¿Para qué tipo de empresa es SAGA Fiscal?",
  "¿Puedo comparar mi operación entre diferentes meses o años?",
];

const Hero: React.FC = () => {
  const [draftQuestion, setDraftQuestion] = useState("");

  const { askQuestion, loading, messages } = useChatStore();
  const { scrollToRef, planesRef, videoSliderRef } = useScroll();

  const handleSelectQuestion = (q: string) => {
    setDraftQuestion(q);
  };

  const handleSubmit = async () => {
    if (!draftQuestion) return;

    await askQuestion(draftQuestion);
    setDraftQuestion("");
  };

  return (
    <Box
      w="100%"
      bg="#F7F9FF"
      display="flex"
      alignItems="flex-start"
      justifyContent="center"
    >
      <VStack textAlign="center" w="100%" px={{ base: 4, md: 8, xl: 0 }}>
        {/* LOGO */}
        <Box maxWidth="116px" w="100%" aspectRatio={117 / 163}>
          <Suspense fallback={null}>
            <Lottie animationData={logoSagaAzulAnim} loop={false} />
          </Suspense>
        </Box>

        {/* TITULOS */}
        <Flex direction="column" align="center">
          <Text
            as="h1"
            fontSize={{ base: "2xl", md: "38px" }}
            fontWeight="700"
            color="#0E2EFB"
            w="full"
            maxW="1100px"
            textAlign="center"
            mb={3}
            data-aos="fade-up"
            data-aos-anchor-placement="top-bottom"
          >
            Claridad y control sobre tu operación fiscal, en tiempo real.
          </Text>

          <Text
            fontSize={{ base: "lg", md: "24px" }}
            color="black.600"
            maxW="850px"
            textAlign="center"
            fontWeight={400}
            data-aos="fade-up"
            data-aos-anchor-placement="top-bottom"
          >
            Agente fiscal inteligente que valida tus CFDIs, detecta inconsistencias antes de que escalen ante el SAT. Tú defines qué hacer; el agente ejecuta con precisión.
          </Text>
        </Flex>

        <Flex gap={4} pt={8} pb={12} direction={{ base: "column", md: "row" }} align="center" w={{ base: "100%", md: "auto" }} px={{ base: 4, md: 0 }} data-aos="fade-up" data-aos-anchor-placement="top-bottom">
          <PrimaryButton fontWeight={'normal'} label="Pruébalo gratis 2 semanas" fontSize={{ base: "16px", md: "20px" }} bg="blue.500" color="white" _hover={{ bg: "blue.600" }} w={{ base: "100%", md: "287px" }} onClick={() => scrollToRef(planesRef)} />
          <PrimaryButton fontWeight={'normal'} label="Ver cómo funciona" w={{ base: "100%", md: "287px" }} fontSize={{ base: "16px", md: "20px" }} onClick={() => scrollToRef(videoSliderRef)} />
        </Flex>

        {/* CHAT */}
        <Box w="full" pt={5} pb={15} px={{ base: 2, md: 8, xl: "115px" }}>
          <Chat />
          {messages.length === 0 && (
            <Box data-aos="fade-up" data-aos-anchor-placement="top-bottom">
              <QuickQuestions
                questions={quickQuestions}
                onSelect={handleSelectQuestion}
              />
            </Box>
          )}
          <Box data-aos="fade-up" data-aos-anchor-placement="top-bottom">
            <HeroInput
              value={draftQuestion}
              onSubmit={handleSubmit}
              disabled={loading}
            />
          </Box>
        </Box>
      </VStack>
    </Box>
  );
};

export default Hero;
